import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { useToken } from '../../../../../providers/Token.provider';
import styles from './FilteredBank.module.scss';
import { useDatadogLog } from '@/hooks/useDatadogLog';

export type TopBankItemProps = {
  selectedClass: string;
  bank: vp.FinancialInstitutionInfo;
  onClick: () => void;
};

type FC = FunctionComponent<TopBankItemProps>;

const TopBankItem: FC = ({ bank, onClick }: TopBankItemProps) => {
  const { token } = useToken();
  const { datadogLog } = useDatadogLog();

  const handleClick = () => {
    datadogLog({
      message: `${bank.FinancialInstitutionNumber} | ${bank.FIName} was clicked`,
      payload: {
        label: 'TopBankItem',
        value: bank,
      },
      actionType: 'Button',
    });

    onClick();
  };
  return (
    <li>
      <button className={styles.topBankButton} type="button" onClick={handleClick}>
        {token?.Country === 'CA' ? (
          <img
            src={
              String(bank.FinancialInstitutionID) === '1894'
                ? '/images/banks-circular-logos/CA/VoPay.svg'
                : String(bank.FinancialInstitutionID) === '1'
                ? '/images/banks-circular-logos/CA/BMO.svg'
                : String(bank.FinancialInstitutionID) === '2'
                ? '/images/banks-circular-logos/CA/Scotia.svg'
                : String(bank.FinancialInstitutionID) === '3'
                ? '/images/banks-circular-logos/CA/RBC.svg'
                : String(bank.FinancialInstitutionID) === '4'
                ? '/images/banks-circular-logos/CA/TD.svg'
                : String(bank.FinancialInstitutionID) === '6'
                ? '/images/banks-circular-logos/CA/CIBC.svg'
                : ''
            }
            alt={bank.FIName}
          />
        ) : (
          <img
            src={
              String(bank.ExternalFIID) === '916'
                ? '/images/banks-circular-logos/US/Chase.svg'
                : String(bank.ExternalFIID) === '2'
                ? '/images/banks-circular-logos/US/Chase.svg'
                : String(bank.ExternalFIID) === '2393'
                ? '/images/banks-circular-logos/US/BoA.svg'
                : String(bank.ExternalFIID) === '10'
                ? '/images/banks-circular-logos/US/Citi.svg'
                : String(bank.ExternalFIID) === '6'
                ? '/images/banks-circular-logos/US/Bancorp.svg'
                : String(bank.ExternalFIID) === '21'
                ? '/images/banks-circular-logos/US/PNC.svg'
                : String(bank.ExternalFIID) === '17501'
                ? '/images/banks-circular-logos/US/CapitalOne.svg'
                : String(bank.ExternalFIID) === '1833'
                ? '/images/banks-circular-logos/US/TD.svg'
                : ''
            }
            alt={bank.FIName}
          />
        )}
      </button>
    </li>
  );
};

export default TopBankItem;
